module.exports = __webpack_public_path__ + "static/bottlerack-a88682b29f8ad1e4b7777c67e3f316f6.jpg";